import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import { FeatureTaxClientListComponent } from './tax-client-list/feature-tax-client-list.component';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {FeatureTaxAllowanceDetailsModule} from "@snelstart-ventures/fiscaal/feature-tax-allowance-details";
import {SharedUiIconModule} from "@snelstart/ui-icon";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@NgModule({
  imports: [
    CommonModule,
    SharedUiTableModule,
    SharedUiButtonModule,
    FeatureTaxAllowanceDetailsModule,
    SharedUiIconModule,
    SharedUiTooltipModule,
    SharedUiDialogModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
  ],
  declarations: [],
  exports: [],
})
export class FeatureTaxClientListModule {}
